export default {"src":"/_next/static/media/nesine.7e20d0e4.svg","height":18,"width":99};